"use strict";

var _regeneratorRuntime = require("/builds/godoo/frontend/website/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.useGet = exports.useDebounce = exports.useDebounceInt = void 0;

var _react = require("react"),
    _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function asyncGeneratorStep(a, b, c, d, e, f, g) {
  try {
    var h = a[f](g),
        i = h.value;
  } catch (a) {
    return void c(a);
  }

  h.done ? b(i) : Promise.resolve(i).then(d, e);
}

function _asyncToGenerator(a) {
  return function () {
    var b = this,
        c = arguments;
    return new Promise(function (d, e) {
      function f(a) {
        asyncGeneratorStep(h, d, e, f, g, "next", a);
      }

      function g(a) {
        asyncGeneratorStep(h, d, e, f, g, "throw", a);
      }

      var h = a.apply(b, c);
      f(void 0);
    });
  };
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

var payload = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-auth-token": "eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNTU0MTE4MDA4Mjc4LCJsYW5ndWFnZSI6ImVuX0dCIiwidmFsaWRGcm9tIjpudWxsLCJleHAiOjE1NTQ3MjI4MDgsInVzZXJJZCI6IjEwMF81YjQ3NWFkOTc3ODMwYTAwMDY2Yjk0ZjIiLCJkZXZpY2UiOiJ3ZWJ1aSIsInVzZXJuYW1lIjoiUklKQTAxIiwidmFsaWRUbyI6bnVsbH0.MXm-e58xU0BIFXg9N3RObxWphrMt9uOeZgdTIxb5zF9aDdYkzOz0EJO2eqvkLABFWX1XpTzOwmUHRLz_1kXSbg"
  },
  resolveWithFullResponse: !0,
  data: null // used to fix axios 415 error

},
    useDebounceInt = function useDebounceInt(a, b) {
  var c = (0, _react.useState)(a),
      d = _slicedToArray(c, 2),
      e = d[0],
      f = d[1]; // when searchValue changes the function useDebounce is called


  return (0, _react.useEffect)(function () {
    // set debouncedValue to value (passed in) after the specified delay
    var c = setTimeout(function () {
      f(a);
    }, b);
    return function () {
      clearTimeout(c);
    };
  }, [a]), e;
};

exports.useDebounceInt = useDebounceInt;

var useDebounce = function useDebounce(a, b) {
  var c = (0, _react.useState)(a),
      d = _slicedToArray(c, 2),
      e = d[0],
      f = d[1];

  return (0, _react.useEffect)(function () {
    var c = setTimeout(function () {
      f(a);
    }, b);
    return function () {
      clearTimeout(c);
    };
  }, [a]), e;
};

exports.useDebounce = useDebounce;

var dataReducer = function dataReducer(a, b) {
  var c = b.payload;

  switch (b.type) {
    case "INIT":
      return _objectSpread({}, a, {
        isLoading: !0,
        isError: !1
      });

    case "FAILURE":
      return _objectSpread({}, a, {
        isLoading: !1,
        isError: !0,
        data: null,
        status: null == c ? null : +c.status
      });

    case "FETCH_SUCCESS":
      return _objectSpread({}, a, {
        isLoading: !1,
        isError: !1,
        data: c.data,
        totalRecords: +c.headers["x-total-count"]
      });

    case "POST_SUCCESS":
      return _objectSpread({}, a, {
        isLoading: !1,
        isError: !1,
        status: +c.status
      });

    case "PUT_SUCCESS":
      return _objectSpread({}, a, {
        isLoading: !1,
        isError: !1,
        status: +c.status
      });

    case "DELETE_SUCCESS":
      return _objectSpread({}, a, {
        isLoading: !1,
        isError: !1,
        status: +c.status
      });

    default:
      return a;
  }
},
    useGet = function useGet(a, b) {
  var c = (0, _react.useState)(a),
      d = _slicedToArray(c, 2),
      e = d[0],
      f = d[1],
      g = (0, _react.useState)(!1),
      h = _slicedToArray(g, 2),
      i = h[0],
      j = h[1],
      k = (0, _react.useReducer)(dataReducer, {
    isLoading: !1,
    isError: !1,
    data: b,
    totalRecords: null,
    status: null
  }),
      l = _slicedToArray(k, 2),
      m = l[0],
      n = l[1];

  return (0, _react.useEffect)(function () {
    var a = !1,
        b = /*#__PURE__*/function () {
      var b = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function b() {
        var c, d;
        return _regeneratorRuntime.wrap(function (b) {
          for (;;) {
            switch (b.prev = b.next) {
              case 0:
                return n({
                  type: "INIT"
                }), b.prev = 1, b.next = 4, _axios["default"].get(e, payload);

              case 4:
                c = b.sent, a || n({
                  type: "FETCH_SUCCESS",
                  payload: c
                }), b.next = 12;
                break;

              case 8:
                b.prev = 8, b.t0 = b["catch"](1), d = b.t0.request, a || n({
                  type: "FAILURE",
                  payload: d
                });

              case 12:
              case "end":
                return b.stop();
            }
          }
        }, b, null, [[1, 8]]);
      }));

      return function () {
        return b.apply(this, arguments);
      };
    }();

    return b(), function () {
      a = !0;
    };
  }, [e, i]), [m, function callApi(a, b) {
    f(a), j(b);
  }];
};

exports.useGet = useGet;